<template>
  <div class="filter-container">
    <div class="filter">
      <ul>
        <li v-if="clientsOptions && clientsOptions.length" class="contract-template">
          <Select
            :required="false"
            :indent="false"
            :model="state"
            @change="onClientChange"
            name="client_id"
            :options="clientsOptions"
          />
        </li>
        <li
          v-if="client && client.contract_templates && client.contract_templates.length"
          class="contract-template"
        >
          <Select
            :required="false"
            label="Profiel"
            :model="state"
            @change="onContractTemplateChange"
            name="contract_template_id"
            :allowsNull="true"
            :textWhenNull="`(${i18n.database.table.contract_templates.texts.no_profile})`"
            :options="contractTemplateOptions"
          />
        </li>
      </ul>

      <h2 class="d-flex justify-content-between" v-if="shouldShowFilters()">
        {{ i18n.app.components.home.filters }}
        <a
          @click="onResetClick"
          class="filter-reset"
        >{{ i18n.buttons.reset }}</a>
      </h2>

      <ul v-for="filterGroup in filterGroupCollection.groups" v-bind:key="filterGroup.key">
        <HomeSidebarFilterComponent
          ref="sidebarFilter"
          @close="onFilterPanelClose"
          @change="onFilterChange"
          @consequence="onFilterConsequence"
          v-for="filter in filterGroup.items"
          v-bind:key="filter.key"
          :filter="filter"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import HomeSidebarFilterComponent from "./HomeSidebarFilterComponent";
import { mapGetters } from "vuex";
import { Select } from "@/components/common/form";
import Client from "@/models/Client";
import * as get from "lodash/get";
import FilterGroupCollection from "@/objects/FilterGroupCollection";

export default {
  name: "home-sidebar",
  props: {
    filterGroupCollection: FilterGroupCollection,
  },
  components: {
    HomeSidebarFilterComponent,
    Select
  },
  data() {
    return {
      // clinttext_when_null: `(${i18n.database.table.contract_templates.texts.no_profile})`,
      text_when_null: `(${i18n.database.table.contract_templates.texts.no_profile})`,
      selected_filter: null,
      state: {
        client_id: this.filterGroupCollection.getClientId(),
        contract_template_id: this.filterGroupCollection.getContractTemplateId(),
      }
    };
  },
  methods: {
    /* Poops out a dictionary of filter criteria */
    getValue() {
      this.filterGroupCollection.getValue();
    },
    onFilterPanelClose(filter) {
      this.$emit("closeFilterPanel", filter);
    },
    onFilterChange(filter) {
      this.$emit("filterChange", filter);
    },
    onResetClick() {
      this.$emit("reset");
    },
    onClientChange() {
      this.state.contract_template_id = "";
      const client = this.clients.find(c => c.id == this.state.client_id);
      this.$emit("clientChange", new Client(client));
    },
    onContractTemplateChange(contractTemplateId) {
      const ct = this.client.contract_templates.find(
        item => item.id == contractTemplateId
      );

      this.$emit("contractTemplateChange", ct);
    },
    onFilterConsequence(map) {
      for (const key in map) {
        if (map.hasOwnProperty(key)) {
          const value = map[key];
          const filter = this.filterGroupCollection.findFilterByKey(key);

          filter.appendValue(value);
          filter.updateSelection();
          filter.updateState();
        }
      }
    },
    shouldShowFilters() {
      return !this?.filterGroupCollection?.contract_template?.is_goplanner_profile
    },
  },
  computed: {
    client() {
      return this.filterGroupCollection.client;
    },

    contractTemplateOptions() {
      return this.client.contract_templates.map(item => ({ value: item.id, text: item.name }));
    },

    ...mapGetters({
      clientsOptions: "clientsOptions",
      clients: "clients"
    })
  }
};
</script>
